import type { QueryFunctionContext } from '@tanstack/react-query';
import { SsoProviderService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { ssoProvidersKeys } from 'app/queries/ssoProviders/ssoProvidersKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof ssoProvidersKeys.list>>;

export const createFetchSsoProvidersQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        SsoProviderService.findAll({
          pageNo: params.page.toString(),
          pageSize: params.pageSize.toString(),
          orderBy: params.orderBy,
          orderType: params.orderType,
          search: params.search,
        }),
        signal,
      ),
    );
